export default __webpack_public_path__ + "6e03e86c9169eb972b989c9cadad44b7.svg";